<template>
  <div class="cash-deposit">
    <p>保证金余额:￥</p>
    <div class="tableTitle">
      <p>保证金明细</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang="scss">
.cash-deposit {
  .tableTitle {
    height: 30px;
    width: 90px;
    margin-right: 1px;
    border-radius: 8px 8px 0px 0px;
    background-color: rgb(239, 239, 239);
    p {
      color: #000;
      font-size: 14px;
      width: 100%;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/cashDeposit.vue